import { FC } from 'react';
import { Paragraph } from '@/UI/Atoms/Paragraph';

import { Container } from './LocalIconInfo.styles';
import { LocalIconInfoProps } from './types';

export const LocalIconInfo: FC<LocalIconInfoProps> = ({ info, className, testId }) => (
  <Container>
    <Paragraph weight="light" className={`iconInfoText ${className}`} data-testid={testId}>
      {info}
    </Paragraph>
  </Container>
);
